import React from 'react'
import BookingInputs from './BookingInputs'
import { motion } from 'framer-motion'
// utils
import PropTypes from 'prop-types'
import { get } from 'lodash'
// styles
import './styles.bh.scss'

export default function BookingForm({ data }) {
  const _props = {
    inputsData: {
      title: get(data, ['title'], ''),
      dateFormat: get(data, ['dateFormat'], ''),
      hotelList: get(data, ['hotelList'], []),
      hotelLoading: get(data, ['hotelLoading'], true),
    },
  }

  return (
    <motion.div
      transition={{
        duration: 0.7,
        delay: 0.1,
      }}
      viewport={{
        once: true,
      }}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      exit={{ opacity: 1 }}
      className="containerForm"
    >
      <div className="col-span-1 xl:col-span-2 hidden md:block" />
      <BookingInputs data={_props.inputsData} />
      <div className="col-span-1 xl:col-span-2 hidden md:block" />
    </motion.div>
  )
}

BookingForm.propTypes = {
  data: PropTypes.object,
}
